export enum SochIcon {
  CLIPBOARD_LIST = 'soch-icons-clipboard-list',
  DRAG = 'soch-icons-drag',
  HOUSE = 'soch-icons-house',
  SCALE = 'soch-icons-scale',
  WALLET = 'soch-icons-wallet',
  UNDO = 'soch-icons-undo',
  REDO = 'soch-icons-redo',
  ITALIC = 'soch-icons-italic',
  STRIKE = 'soch-icons-strike',
  UNDERLINE = 'soch-icons-underline',
  BOLD = 'soch-icons-bold',
  ORDER_LIST = 'soch-icons-order-list',
  UNORDER_LIST = 'soch-icons-unorder-list',
  ALIGN_LEFT = 'soch-icons-align-left',
  ALIGN_RIGHT = 'soch-icons-align-right',
  ALIGN_CENTER = 'soch-icons-align-center',
  JUSTIFY = 'soch-icons-justify',
  H1 = 'soch-icons-h1',
  H2 = 'soch-icons-h2',
  H3 = 'soch-icons-h3',
  P = 'soch-icons-p',
}
